import { METRICS, SOCIAL_PLATFORMS } from '~/constants';
import { MediaPackBenchmarkType } from '~/types';
import { pluralize } from '~/utils';

import { METRIC_CONFIG } from './MediaPackDetailEditHighlightsModal.constants';

export type TValidate = { [k in METRICS]: MediaPackBenchmarkType[] };
export type TValidateErrors = { [k in METRICS]?: string };

export const validate = (
  metricsPosition: TValidate,
  platform: SOCIAL_PLATFORMS,
): TValidateErrors =>
  Object.entries(metricsPosition).reduce(
    (acc: TValidateErrors, [metric, benchmarks]) => {
      const config = METRIC_CONFIG[platform][metric as METRICS];
      if (config.isMultiselect && benchmarks.length < config.minMetricCount) {
        acc[metric as METRICS] = pluralize(
          `You have to choose 1 metric`,
          `You have to choose ${config.minMetricCount} metrics`,
          config.minMetricCount,
        );
      } else if (!benchmarks.length) {
        acc[metric as METRICS] = `You have to choose 1 metric`;
      }
      return acc;
    },
    {},
  );
